import { render, staticRenderFns } from "./MessageRecipientLists.vue?vue&type=template&id=2e33d625&scoped=true"
import script from "./MessageRecipientLists.vue?vue&type=script&lang=js"
export * from "./MessageRecipientLists.vue?vue&type=script&lang=js"
import style0 from "./MessageRecipientLists.vue?vue&type=style&index=0&id=2e33d625&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33d625",
  null
  
)

export default component.exports